module.exports = __webpack_public_path__ + "img/03draafge.8de4606a.png";